import React from 'react';
import { testimonials } from '../data/matematik';
export function Testimonials() {
  // Hidden until authentic NATURKLAR reviews are added in data/naturklar.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-287" data-mp="3fym70jljx03t">
      <div className="mx-auto max-w-6xl" data-id="element-288" data-mp="3azjetzqo6od9">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-289" data-mp="3ayqdjeahcr2i">
          Det siger <em className="text-red-700" data-id="element-290" data-mp="32060otrlpbm7">lærerne</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-291" data-mp="31yl6x6d41wpe">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-292" data-mp="2x2mlnrn2wut7">
              <div className="text-sm text-amber-500" aria-label="5 / 5 stjerner" data-id="element-293" data-mp="2s39syq9j0tip">
                <span aria-hidden="true" data-id="element-294" data-mp="v859txg9hd2s">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-295" data-mp="q9u15q1pd8m5">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-296" data-mp="h8197snheoml">
                <span className="font-semibold text-slate-900" data-id="element-297" data-mp="m5b2jjdzrkfp">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-298" data-mp="78abzj7jdvit"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}